import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './components/navigation/Navbar'
import Sidebar from './components/navigation/Sidebar'
import Home from './components/pages/home/Home'
import Destination from './components/pages/destination/Destination'
import { useState } from 'react'
import Crew from './components/pages/crew/Crew'
import Technology from './components/pages/technology/Technology'

function App() {
    const [showNav, setShowNav] = useState(false)
    function handleNavToggle() {
        setShowNav((prevShowNav) => !prevShowNav)
        console.log(showNav)
    }
    return (
        <div className='app'>
            <Router>
                <Navbar
                    handleNavToggle={handleNavToggle}

                    // setNavToggle={setNavToggle}
                />
                {showNav ? (
                    <Sidebar
                        handleNavToggle={handleNavToggle}
                        showNav={showNav}
                    />
                ) : null}
                {/* <Sidebar
                    handleNavToggle={handleNavToggle}
                    navToggle={navToggle}
                /> */}
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/destination' element={<Destination />} />
                    <Route path='/crew' element={<Crew />} />
                    <Route path='/technology' element={<Technology />} />
                </Routes>
            </Router>
        </div>
    )
}

export default App
